<template>
    <div class="flex">
        <div class="px-3 py-2 items-center" :class="{'flex' : labelLeft}">
            <div class="text-xs">{{label}}</div>
            <div class="text-2xl" :class="{'ml-5' : labelLeft, 'pt-5': !labelLeft}">{{value}}</div>
        </div>
    </div>
</template>

<script>

import { Link } from '@inertiajs/vue2';


export default {
    components: {
        Link,
    },
    props: {
        label: String,
        value: String,
        labelLeft: {
            type: Boolean,
            default: true
        }
    }
}
</script>
